"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Interceptor_1 = __importDefault(require("../interceptor/Interceptor"));
var QueryContext_1 = __importDefault(require("./QueryContext"));
var combineQueryContext = function (context, override) {
    var _a;
    if (!override) {
        return context !== null && context !== void 0 ? context : new QueryContext_1.default();
    }
    var contextMap = (_a = context === null || context === void 0 ? void 0 : context.getContextEntries()) !== null && _a !== void 0 ? _a : new Map();
    var overrideMap = override.getContextEntries();
    var resultMap = new Map();
    contextMap.forEach(function (value, key) {
        resultMap.set(key, value);
    });
    overrideMap.forEach(function (value, key) {
        resultMap.set(key, value);
    });
    return new QueryContext_1.default(resultMap);
};
var combineWeblabContext = function (context, override) {
    if (!override) {
        return context;
    }
    return override;
};
var ContextInjector = /** @class */ (function (_super) {
    __extends(ContextInjector, _super);
    function ContextInjector(queryContextProvider, weblabContextProvider) {
        var _this = _super.call(this) || this;
        _this.queryContextProvider = queryContextProvider;
        _this.weblabContextProvider = weblabContextProvider;
        return _this;
    }
    ContextInjector.prototype.after = function () {
    };
    ContextInjector.prototype.before = function (methodContext) {
        var _a, _b;
        methodContext.queryContext = combineQueryContext((_a = this.queryContextProvider) === null || _a === void 0 ? void 0 : _a.get(), methodContext.queryContext);
        methodContext.weblabContext = combineWeblabContext((_b = this.weblabContextProvider) === null || _b === void 0 ? void 0 : _b.get(), methodContext.weblabContext);
    };
    return ContextInjector;
}(Interceptor_1.default));
exports.default = ContextInjector;
